import React, { useState } from "react";
import axios from "../utils/axios";

function DemoForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message:
      "I'd like to schedule a walkthrough of WebVenly for my organization.",
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(false);

    try {
      await axios.post("/api/demo", formData);
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        company: "",
        message:
          "I'd like to schedule a walkthrough of WebVenly for my organization.",
      });
    } catch (err) {
      setError("Something went wrong. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="card shadow-sm p-4 mx-auto" style={{ maxWidth: "600px" }}>
      <h4 className="mb-4">Request a Demo</h4>

      {submitted && (
        <div className="alert alert-success">
          ✅ Thank you for your interest in WebVenly! Our team will reach out
          shortly to schedule your personalized demo.
        </div>
      )}

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            name="email"
            type="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Company</label>
          <input
            name="company"
            className="form-control"
            value={formData.company}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Message</label>
          <textarea
            name="message"
            className="form-control"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            placeholder="Tell us what you're looking for, your timeline, or any questions..."
          />
        </div>

        <div className="d-grid">
          <button className="btn btn-primary" type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default DemoForm;
